import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/zztj.png'


const _hoisted_1 = {
  class: "page",
  style: {"padding":"16px"}
}

import { reactive } from 'vue';
import type { TabsPaneContext } from 'element-plus'
import AboutView from "@/views/AboutView.vue";
import { ref } from 'vue'
import BenefitsView from "@/views/BenefitsView.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const activeName = ref('first')

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event)
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { style: {} }, [
      _createElementVNode("img", {
        style: {"width":"60px"},
        src: _imports_0
      }),
      _createElementVNode("div", { style: {"font-size":"36px","font-weight":"bolder","color":"red"} }, "五分钟教你打赢仲裁")
    ], -1)),
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      class: "demo-tabs",
      onTabClick: handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "离职补偿金",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createVNode(AboutView)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "失业保险金",
          name: "second"
        }, {
          default: _withCtx(() => [
            _createVNode(BenefitsView)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})